import { render, staticRenderFns } from "./MyCallSummary.vue?vue&type=template&id=18f3cd1f&scoped=true"
import script from "./MyCallSummary.vue?vue&type=script&lang=js"
export * from "./MyCallSummary.vue?vue&type=script&lang=js"
import style0 from "./MyCallSummary.vue?vue&type=style&index=0&id=18f3cd1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f3cd1f",
  null
  
)

export default component.exports